import React from 'react';
import SectionContainer from '../../../../F22/common/SectionContainer';
import { formatCurrency } from '../../../../F22/common/formatUtils';
import { r21 as r21Fn } from '../formulas';

const Cell = ({ code, value }) => (
  <div className="f22-rtre-cell">
    {code && <span className="f22-rtre-code">{code}</span>}
    <span>{value !== undefined && value !== 0 ? formatCurrency(value) : ''}</span>
  </div>
);

const R21Section = ({ data }) => {
  const rem      = r21Fn.remanente(data);
  const idpcBI   = r21Fn.idpcBI(data);
  const idpcDiv  = r21Fn.idpcDividendo(data);
  const asigRet  = r21Fn.asignadoRetiros(data);
  const gastosR  = r21Fn.gastosRechazados(data);
  const remSig   = r21Fn.remanenteSiguiente(data);

  // Columnas: noSujetoSinDev, noSujetoConDev, sujetoConDev, ipeSinDev, sac2016
  const rows = [
    {
      label: 'Remanente ejercicio anterior',
      codes: { noSujetoSinDev: '1495', noSujetoConDev: '1496', sujetoConDev: '1498', ipeSinDev: '1499', sac2016: '1502' },
      values: { noSujetoSinDev: rem.SAC_noSujetoSinDev, noSujetoConDev: rem.SAC_noSujetoConDev, sujetoConDev: rem.SAC_sujetoConDev, ipeSinDev: rem.SAC_IPE_sinDev, sac2016: rem.SAC_2016_conDev },
    },
    {
      label: 'IDPC e IPE base imponible generada en el ejercicio',
      codes: { noSujetoSinDev: '1512', noSujetoConDev: '1513', ipeSinDev: '1514' },
      values: { noSujetoSinDev: idpcBI.SAC_IPE_sinDev, noSujetoConDev: idpcBI.SAC_noSujetoConDev, ipeSinDev: idpcBI.SAC_IPE_IF },
    },
    {
      label: 'IDPC e IPE retiros o dividendos percibidos',
      codes: { noSujetoSinDev: '1515', noSujetoConDev: '1516', sujetoConDev: '1518', ipeSinDev: '1519', sac2016: '1521' },
      values: { noSujetoConDev: idpcDiv.SAC_noSujetoConDev, sujetoConDev: idpcDiv.SAC_sujetoConDev, sac2016: idpcDiv.SAC_2016_conDev },
    },
    {
      label: 'Asignado a retiros',
      codes: { noSujetoSinDev: '1539', noSujetoConDev: '1540', sujetoConDev: '1542', ipeSinDev: '1543', sac2016: '1547' },
      values: { noSujetoSinDev: asigRet.SAC_noSujetoSinDev, noSujetoConDev: asigRet.SAC_noSujetoConDev, ipeSinDev: asigRet.SAC_IPE },
    },
    {
      label: 'IDPC e IPE asignado a gastos rechazados',
      codes: { noSujetoSinDev: '1557', noSujetoConDev: '1558', ipeSinDev: '1559', sac2016: '1561' },
      values: { noSujetoConDev: gastosR.SAC_noSujetoConDev },
    },
    {
      label: 'Remanente ejercicio siguiente',
      codes: { noSujetoSinDev: '1563', noSujetoConDev: '1564', sujetoConDev: '1566', ipeSinDev: '1567', sac2016: '1569' },
      values: { noSujetoSinDev: remSig.SAC_noSujetoSinDev, noSujetoConDev: remSig.SAC_noSujetoConDev, sujetoConDev: remSig.SAC_sujetoConDev, ipeSinDev: remSig.SAC_IPE_sinDev, sac2016: remSig.SAC_2016_conDev },
      isTotal: true,
    },
  ];

  const columns = [
    { key: 'noSujetoSinDev', label: 'No Suj. S/Dev' },
    { key: 'noSujetoConDev', label: 'No Suj. C/Dev' },
    { key: 'sujetoConDev',   label: 'Suj. C/Dev' },
    { key: 'ipeSinDev',      label: 'IPE' },
    { key: 'sac2016',        label: 'Créd. 2016' },
  ];

  return (
    <SectionContainer title="Recuadro N° 21" subtitle="Registro SAC (Art. 14 letra D) N° 3 LIR)">
      <div className="f22-rtre-table-wrapper">
        <div className="f22-rtre-table">
          <div className="f22-rtre-header">
            <div className="f22-rtre-cell f22-rtre-header-cell" style={{ flex: 3 }}>Detalle</div>
            {columns.map((col) => (
              <div key={col.key} className="f22-rtre-cell f22-rtre-header-cell">{col.label}</div>
            ))}
          </div>
          {rows.map((row, i) => (
            <div key={i} className={`f22-rtre-row ${row.isTotal ? 'f22-rtre-total' : ''}`}>
              <div className="f22-rtre-cell" style={{ flex: 3, textAlign: 'left', fontFamily: 'inherit' }}>
                {row.label}
              </div>
              {columns.map((col) => (
                <Cell key={col.key} code={row.codes?.[col.key]} value={row.values[col.key]} />
              ))}
            </div>
          ))}
        </div>
      </div>
    </SectionContainer>
  );
};

export default R21Section;
